<div style="text-align: center">
  <h2>{{ title }}</h2>
</div>
